import { useLocation } from "react-router-dom";
import { useAppSettings, buildWhatsAppUrl } from "@/hooks/useAppSettings";
import { MessageCircle } from "lucide-react";

export function WhatsAppFloat() {
  const location = useLocation();
  const { settings } = useAppSettings();

  if (location.pathname.startsWith("/admin")) return null;

  const url = buildWhatsAppUrl(settings?.WHATSAPP_NUMBER, settings?.WHATSAPP_MESSAGE);
  if (!url) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 transition-transform"
    >
      <MessageCircle className="w-7 h-7" fill="currentColor" />
    </a>
  );
}